import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const FORMULAIRE_VIDE = {
    name: '',
    email: '',
    message: '',
    honeypot: '', // Champ caché (honeypot)
};

const ContactForm = () => {
    const [formData, setFormData] = useState(FORMULAIRE_VIDE);
    const [sending, setSending] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (sending) return; // pas de double envoi

        // Vérifier le champ honeypot
        if (formData.honeypot) {
            alert('Erreur: Soumission détectée comme bot.');
            return;
        }

        const { honeypot, ...champs } = formData;
        setSending(true);
        emailjs.send(
            'service_2kavgmh', // Remplacez par votre Service ID EmailJS
            'template_4u6kb37', // Remplacez par votre Template ID EmailJS
            champs,
            'FrIKB_141AV-mZ7QA' // Remplacez par votre Public Key EmailJS
        ).then((response) => {
            console.log('SUCCESS!', response.status, response.text);
            alert('Email envoyé avec succès');
            setFormData(FORMULAIRE_VIDE);
        }, (err) => {
            console.log('FAILED...', err);
            alert('Erreur lors de l\'envoi de l\'email');
        }).finally(() => setSending(false));
    };

    return (
        <form onSubmit={handleSubmit} style={{ maxWidth: '600px', margin: 'auto', padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
            <div style={{ marginBottom: '15px' }}>
                <label htmlFor="name" style={{ display: 'block', marginBottom: '5px' }}>Nom:</label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                    placeholder="Entrez votre nom"
                    required
                />
            </div>
            <div style={{ marginBottom: '15px' }}>
                <label htmlFor="email" style={{ display: 'block', marginBottom: '5px' }}>Email:</label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                    placeholder="Entrez votre email"
                    required
                />
            </div>
            <div style={{ marginBottom: '15px' }}>
                <label htmlFor="message" style={{ display: 'block', marginBottom: '5px' }}>Message:</label>
                <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                    rows="5"
                    placeholder="Entrez votre message"
                    required
                />
            </div>
            <div style={{ display: 'none' }}>
                <label htmlFor="honeypot">Ne remplissez pas ce champ:</label>
                <input
                    type="text"
                    id="honeypot"
                    name="honeypot"
                    value={formData.honeypot}
                    onChange={handleChange}
                    tabIndex={-1}
                    autoComplete="off"
                />
            </div>
            <button type="submit" disabled={sending} style={{ backgroundColor: '#007bff', color: '#fff', padding: '10px 15px', border: 'none', borderRadius: '4px', cursor: sending ? 'wait' : 'pointer' }}>
                {sending ? 'Envoi…' : 'Envoyer'}
            </button>
        </form>
    );
};

export default ContactForm;
